import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchStatisticsBestReaderSelectItemResult,
  BatchStatisticsBestReaderSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsBestReaderSelectItemResult'
import {
  BatchStatisticsBestReaderRequest,
  BatchStatisticsBestReaderRequestToJSON
} from '@/api/models/batch/BatchStatisticsBestReaderRequest'

export class BatchStatisticsBestReaderApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchStatisticsBestReaderSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsBestReaderSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 帳票作成
   * @param request
   */
  async createBestReader(
    request: BatchStatisticsBestReaderRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/best-reader`,
      BatchStatisticsBestReaderRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
